import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from '../../../services/notification.service';
import { FormularioService } from '../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';


@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-rs005-card-IV',
    templateUrl: './rs005-card-IV.component.html'
})

export class Rs005CardIVComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public isG0: boolean = false;
    @Output() objMakeCalculations = new EventEmitter();

    @Output() calDatesEvent = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Cálculos de Peso', false);
        if (this.isComercial || this.isBasica) {
            this.formulario = this.formBuilder.group({
                Peso_palha_carga_kg: [null, []],
                Peso_liquido_carga_umidade_kg: [null, []],
                Perda_processo_kg: [null, []],
                Peso_espigas_inteiras_perdidas_kg: [null, []],
            });
        }
        else if (this.isPreBasica) {
            this.formulario = this.formBuilder.group({
                lote_ds: [null, [Validators.required]],
                numero_caixa: [null, []],
                inicio_debulha_data: [null, [Validators.required, Validators.pattern(this.regexDate)]],
                inicio_debulha_hora: [null, [Validators.required, Validators.pattern(this.regexHour)]],
                umidade_debulha_prc: [null, [Validators.required]],
                numero_bag_iniciado: [null, [Validators.required]],
                numero_bag_finalizado: [null, [Validators.required]],
                peso_bruto_bag_finalizado: [null, [Validators.required]],
                peso_liquido_bag_finalizado: [null, [Validators.required]],
                motivo_parada_debulha: [null, []],
                tempo_parada_debulha_hora: [null, [Validators.required]],
                fim_debulha_data: [null, [Validators.required, Validators.pattern(this.regexDate)]],
                fim_debulha_hora: [null, [Validators.required, Validators.pattern(this.regexHour)]],
                lote_pa: [null, []],
                peso_pa_bruto: [null, []],
                peso_pa_liquido: [null, []],
                descarte_pa: [null, []],
                numero_sacos: [null, []]
            });
            this.step = 'ETAPA 3 (Debulha)'
        }

    }


    async ngOnInit(): Promise<void> {
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    public async makeCalculations(): Promise<void> {
        this.objMakeCalculations.emit();
    }

    validDates($event) {
        if (this.formulario?.get('inicio_debulha_data').value &&
            this.formulario?.get('inicio_debulha_hora').value &&
            this.formulario?.get('fim_debulha_data').value &&
            this.formulario?.get('fim_debulha_hora').value) {
            var dateInit = this.generalService.createDateTimeData(this.formulario?.get('inicio_debulha_data').value, this.formulario?.get('inicio_debulha_hora').value);
            var dateEnd = this.generalService.createDateTimeData(this.formulario?.get('fim_debulha_data').value, this.formulario?.get('fim_debulha_hora').value);

            if (dateInit > dateEnd) {
                this.formulario?.get('fim_debulha_data').setErrors({ error: true });
                this.formulario?.get('fim_debulha_hora').setErrors({ error: true });
            }
            else {
                this.formulario?.get('fim_debulha_data').setErrors(null);
                this.formulario?.get('fim_debulha_hora').setErrors(null);
            }
        }
        this.calDatesEvent.emit();
    }
}

